module.exports = __webpack_public_path__ + "static/media/header-landing-pages-logo-dark.d4ddef77.svg";